import _paths from "./paths";

export const paths = _paths;
export const LOGO_URL = "https://static.inmatics.io/logo_circulo_grande.png";
